import { render } from "./DistributorLanding.vue?vue&type=template&id=d27c2dc0&scoped=true"
import script from "./DistributorLanding.vue?vue&type=script&lang=js"
export * from "./DistributorLanding.vue?vue&type=script&lang=js"

import "./DistributorLanding.vue?vue&type=style&index=0&id=d27c2dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27c2dc0"]])

export default __exports__